exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small-label-width {\r\n    width: 125px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    color: #848484;\r\n}\r\n\r\n.medium-label-width {\r\n    width: 150px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    color: #848484;\r\n}\r\n\r\n.large-label-width {\r\n    width: 175px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    color: #848484;\r\n}\r\n\r\n.xlarge-label-width {\r\n    width: 200px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    color: #848484;\r\n}\r\n\r\n.form-field {\r\n    flex-grow: 1;\r\n}\r\n\r\n.form-group {\r\n    display: flex;\r\n    margin: 5px;\r\n}\r\n\r\ninput {\r\n    height: 30px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/fw/dynamic-forms/dynamic-field.component.css
// module id = 2285
// module chunks = 1